import { render, staticRenderFns } from "./ClientShippingReturn.vue?vue&type=template&id=c3fc56c4"
import script from "./ClientShippingReturn.vue?vue&type=script&lang=js"
export * from "./ClientShippingReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports